import { useEffect, useState } from 'react';
import { fetchEntitledMarkets } from '../lib/bff.client';
import { Market } from '../context/types';
import { UseFetchEntitledMarketsReturnType } from './types';
import { logger } from '@ecosystem/newron-client-lib';

export const useFetchEntitledMarkets = (proposition: string): UseFetchEntitledMarketsReturnType => {
  const [entitledMarkets, setEntitledMarkets] = useState<Market[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchEntitledMarkets(proposition)
      .then(response => {
        setEntitledMarkets(response);
      })
      .catch(error => {
        logger.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [proposition]);

  return { entitledMarkets, isLoading };
};
